// extracted by mini-css-extract-plugin
module.exports = {"footerSignoff":"FooterSignoffButton__footerSignoff___3DIF8","useWFFonts":"FooterSignoffButton__useWFFonts___ax5VM"};